export interface BlockingAbsenceTypeRow {
  key: string;
  behaviorFlags: unknown;
}

// Mirrors the SQL predicate previously duplicated in both API services:
// blocksPlanning wins when set, otherwise falls back to legacy isBlocking.
export function isBlockingAbsenceBehavior(behaviorFlags: unknown): boolean {
  if (!behaviorFlags || typeof behaviorFlags !== 'object') return false;
  const flags = behaviorFlags as Record<string, unknown>;
  if (String(flags['blocksPlanning'] ?? '') === 'true') return true;
  return flags['blocksPlanning'] == null && String(flags['isBlocking'] ?? '') === 'true';
}

export function stripAbsenceTypePrefix(key: string): string {
  return key.startsWith('absence:') ? key.slice('absence:'.length) : key;
}

// Single shared resolution: blocking rows in, prefix-stripped keys out.
export function resolveBlockingAbsenceTypes(rows: readonly BlockingAbsenceTypeRow[]): string[] {
  const keys: string[] = [];
  for (const row of rows) {
    if (isBlockingAbsenceBehavior(row.behaviorFlags)) keys.push(stripAbsenceTypePrefix(row.key));
  }
  return keys;
}
